export const modalConnectSelector = (state) => state.ui.modal.connect;
export const modalShopSelector = (state) => state.ui.modal.shop;

export const isAnyModalOpenSelector = (state) => {
  const values = Object.values(state.ui.modal);
  const isOpen = values.some((value) => !!value);
  return isOpen;
};
